// @flow
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import Login from './Login';
import Register from './Register';
import ForgotPassword from './ForgotPassword';
import { setForm } from '../../actions';
import {
    LOGIN_FORM,
    REGISTER_FORM,
    FORGOT_PASSWORD_FORM,
} from '../../constants/forms';
import i18n from '../../i18n/i18n.js';

type Props = {
    auth: {
        isAuthenticated: boolean,
        language: string,
    },
    language: string,
    form: string,
    branding: Object,
    setForm: Function,
    modal: {
        isTriggerExternal: boolean,
    },
};

type State = {
    activeLogin: boolean,
    activeRegister: boolean,
};

export class Auth extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            activeLogin: true,
            activeRegister: false,
        };
    }

    componentDidMount() {
        if (this.props.modal.isTriggerExternal)
            this.setState({
                activeLogin: this.props.form === LOGIN_FORM,
                activeRegister: this.props.form === REGISTER_FORM,
            });
    }

    changeForm = (form: any) => {
        if (form === LOGIN_FORM) {
            this.setState({
                activeLogin: true,
                activeRegister: false,
            });
        } else if (form === REGISTER_FORM) {
            this.setState({
                activeLogin: false,
                activeRegister: true,
            });
        }

        this.props.setForm(form);
    };

    render() {
        let form = null;
        if (this.props.form === LOGIN_FORM) {
            form = (
                <Login
                    changeForm={this.changeForm}
                    branding={this.props.branding}
                />
            );
        } else if (this.props.form === REGISTER_FORM) {
            form = <Register />;
        } else if (this.props.form === FORGOT_PASSWORD_FORM) {
            form = <ForgotPassword />;
        }

        let lng = this.props.auth.language;

        let borderBottomLogin;
        let borderBottomReg;

        if (this.state.activeLogin) {
            borderBottomLogin = `2px solid ${
                this.props.branding.paywall_primary_color
            }`;
        } else if (this.state.activeRegister) {
            borderBottomReg = `2px solid ${
                this.props.branding.paywall_primary_color
            }`;
        }

        return (
            <Fragment>
                <header>
                    <div className="headline">
                        <a
                            className={
                                'ipx-headlogin ' +
                                (this.state.activeLogin && 'active')
                            }
                            onClick={e => {
                                e.preventDefault();
                                this.changeForm(LOGIN_FORM);
                            }}
                            style={{ borderBottom: borderBottomLogin }}
                        >
                            {i18n.t('modal_login_capital', { lng })}
                        </a>
                        /
                        <a
                            className={
                                'ipx-headregister ' +
                                (this.state.activeRegister && 'active')
                            }
                            href="#"
                            onClick={e => {
                                e.preventDefault();
                                this.changeForm(REGISTER_FORM);
                            }}
                            style={{ borderBottom: borderBottomReg }}
                        >
                            {i18n.t('modal_signup_capital', { lng })}
                        </a>
                    </div>
                    {/* <div className="inplayer-customtext">
                        <p></p>
                    </div> */}
                </header>
                {form}
            </Fragment>
        );
    }
}

const mapStateToProps = (state: Object) => {
    return {
        auth: state.auth,
        form: state.modal.form,
        branding: state.branding,
        modal: state.modal,
    };
};

export default connect(
    mapStateToProps,
    {
        setForm,
    }
)(Auth);



// WEBPACK FOOTER //
// ./src/containers/Forms/Auth.js